import React from 'react';
import './App.css';
import Home from './Component/home/Home';
import { createBrowserRouter, Link, RouterProvider } from 'react-router-dom';
import { Error } from './Component/Error';
import { ProductListing } from './Component/productListing/productListing';
import { Productdetail } from './Component/productDetail/Productdetail';
import { MainLayout } from './Component/MainLayout/MainLayout';

const router = createBrowserRouter([
  {
    path:"/",
    element:<MainLayout/>,
    errorElement:<Error/>,
    children:[
      {
        path:"/",
        element:<Home/>
        },
      {
        path:"/productlisting",
        element:<ProductListing/>
      },
      {
        path:"/ProductDetail/:id",
        element:<Productdetail/>
      },
    ],
    },
]);

function App() {
  return (
    <>
      <RouterProvider router={router}/>
    </>
  );
}

export default App;
